import session from 'lib/session';
import { identity } from 'lodash';
import { createReducer } from 'redux/shelf';
import { del, get, post, put } from 'redux/shelf/api';

export enum SynonymType {
  oneWay = 'one_way',
  twoWay = 'two_way',
}

export const actions = {
  fetch: get`/merchants/${session.getMerchant}/synonyms/:type`((res) => ({
    entities: res.reverse(),
  })),
  create: post`/merchants/${session.getMerchant}/synonyms/:type`(identity),
  update: put`/merchants/${session.getMerchant}/synonyms/:type/:id`(identity),
  remove: del`/merchants/${session.getMerchant}/synonyms/:type/:id`(identity),
  removeBatch: del`/merchants/${session.getMerchant}/synonyms/:type/batch`(
    identity
  ),
  upload: post`/merchants/${session.getMerchant}/synonyms/:type/upload`(
    identity
  ),
  fetchOneWaySynonym: get`/merchants/${session.getMerchant}/synonyms/one_way`(
    (one_way) => ({ one_way })
  ),
  fetchTwoWaySynonym: get`/merchants/${session.getMerchant}/synonyms/two_way`(
    (two_way) => ({ two_way })
  ),
};

const addTypeToSynonym = (synonyms, type) => {
  return synonyms?.map((synonym) => ({
    ...synonym,
    type,
  }));
};

// TODO: change payload
// TODO: sort em by created date
export const reducer = createReducer(actions, {
  [`${actions.fetchOneWaySynonym}`]: (state, { payload }) => {
    return {
      ...state,
      entities: [
        ...(addTypeToSynonym(state.two_way, SynonymType.twoWay) || []),
        ...addTypeToSynonym(payload.one_way, SynonymType.oneWay),
      ],
    };
  },
  [`${actions.fetchTwoWaySynonym}`]: (state, { payload }) => {
    return {
      ...state,
      entities: [
        ...(addTypeToSynonym(state.one_way, SynonymType.oneWay) || []),
        ...addTypeToSynonym(payload.two_way, SynonymType.twoWay),
      ],
    };
  },
  [actions.create]: (s, { payload, meta }) => ({
    entities: [{ ...payload, type: meta.type }, ...s.entities],
  }),
  [actions.update]: (s, { payload }) => ({
    entities: s.entities.map((i) => (i.id !== payload.id && i) || payload),
  }),
  [actions.remove]: (s, { meta }) => ({
    entities: s.entities.filter((i) => i.id !== meta.id),
  }),
});
